export const COLOR_TOKENS = {
  core: {
    silver: {
      1: "var(--core-silver-1)",
      2: "var(--core-silver-2)",
      3: "var(--core-silver-3)",
      4: "var(--core-silver-4)",
      5: "var(--core-silver-5)",
      6: "var(--core-silver-6)",
      7: "var(--core-silver-7)",
      8: "var(--core-silver-8)",
      9: "var(--core-silver-9)",
      10: "var(--core-silver-10)",
      11: "var(--core-silver-11)",
      12: "var(--core-silver-12)",
      a1: "var(--core-silver-a1)",
      a2: "var(--core-silver-a2)",
      a3: "var(--core-silver-a3)",
      a4: "var(--core-silver-a4)",
      a5: "var(--core-silver-a5)",
      a6: "var(--core-silver-a6)",
      a7: "var(--core-silver-a7)",
      a8: "var(--core-silver-a8)",
      a9: "var(--core-silver-a9)",
      a10: "var(--core-silver-a10)",
      a11: "var(--core-silver-a11)",
      a12: "var(--core-silver-a12)",
    },
    blue: {
      1: "var(--core-blue-1)",
      2: "var(--core-blue-2)",
      3: "var(--core-blue-3)",
      4: "var(--core-blue-4)",
      5: "var(--core-blue-5)",
      6: "var(--core-blue-6)",
      7: "var(--core-blue-7)",
      8: "var(--core-blue-8)",
      9: "var(--core-blue-9)",
      10: "var(--core-blue-10)",
      11: "var(--core-blue-11)",
      12: "var(--core-blue-12)",
      a1: "var(--core-blue-a1)",
      a2: "var(--core-blue-a2)",
      a3: "var(--core-blue-a3)",
      a4: "var(--core-blue-a4)",
      a5: "var(--core-blue-a5)",
      a6: "var(--core-blue-a6)",
      a7: "var(--core-blue-a7)",
      a8: "var(--core-blue-a8)",
      a9: "var(--core-blue-a9)",
      a10: "var(--core-blue-a10)",
      a11: "var(--core-blue-a11)",
      a12: "var(--core-blue-a12)",
    },
    gray: {
      1: "var(--core-gray-1)",
      2: "var(--core-gray-2)",
      3: "var(--core-gray-3)",
      4: "var(--core-gray-4)",
      5: "var(--core-gray-5)",
      6: "var(--core-gray-6)",
      7: "var(--core-gray-7)",
      8: "var(--core-gray-8)",
      9: "var(--core-gray-9)",
      10: "var(--core-gray-10)",
      11: "var(--core-gray-11)",
      12: "var(--core-gray-12)",
      a1: "var(--core-gray-a1)",
      a2: "var(--core-gray-a2)",
      a3: "var(--core-gray-a3)",
      a4: "var(--core-gray-a4)",
      a5: "var(--core-gray-a5)",
      a6: "var(--core-gray-a6)",
      a7: "var(--core-gray-a7)",
      a8: "var(--core-gray-a8)",
      a9: "var(--core-gray-a9)",
      a10: "var(--core-gray-a10)",
      a11: "var(--core-gray-a11)",
      a12: "var(--core-gray-a12)",
    },
  },
  inverted: {
    1: "var(--inverted-1)",
    2: "var(--inverted-2)",
    3: "var(--inverted-3)",
    4: "var(--inverted-4)",
    5: "var(--inverted-5)",
    6: "var(--inverted-6)",
    7: "var(--inverted-7)",
    8: "var(--inverted-8)",
    9: "var(--inverted-9)",
    10: "var(--inverted-10)",
    11: "var(--inverted-11)",
    12: "var(--inverted-12)",
    a1: "var(--inverted-a1)",
    a2: "var(--inverted-a2)",
    a3: "var(--inverted-a3)",
    a4: "var(--inverted-a4)",
    a5: "var(--inverted-a5)",
    a6: "var(--inverted-a6)",
    a7: "var(--inverted-a7)",
    a8: "var(--inverted-a8)",
    a9: "var(--inverted-a9)",
    a10: "var(--inverted-a10)",
    a11: "var(--inverted-a11)",
    a12: "var(--inverted-a12)",
  },
  white: {
    a1: "var(--white-a1)",
    a2: "var(--white-a2)",
    a3: "var(--white-a3)",
    a4: "var(--white-a4)",
    a5: "var(--white-a5)",
    a6: "var(--white-a6)",
    a7: "var(--white-a7)",
    a8: "var(--white-a8)",
    a9: "var(--white-a9)",
    a10: "var(--white-a10)",
    a11: "var(--white-a11)",
    a12: "var(--white-a12)",
  },
  black: {
    1: "var(--black-1)",
    2: "var(--black-2)",
    3: "var(--black-3)",
    4: "var(--black-4)",
    5: "var(--black-5)",
    6: "var(--black-6)",
    7: "var(--black-7)",
    8: "var(--black-8)",
    9: "var(--black-9)",
    10: "var(--black-10)",
    11: "var(--black-11)",
    12: "var(--black-12)",
    a1: "var(--black-a1)",
    a2: "var(--black-a2)",
    a3: "var(--black-a3)",
    a4: "var(--black-a4)",
    a5: "var(--black-a5)",
    a6: "var(--black-a6)",
    a7: "var(--black-a7)",
    a8: "var(--black-a8)",
    a9: "var(--black-a9)",
    a10: "var(--black-a10)",
    a11: "var(--black-a11)",
    a12: "var(--black-a12)",
  },
  base: {
    1: "var(--base-1)",
    2: "var(--base-2)",
    3: "var(--base-3)",
    4: "var(--base-4)",
    5: "var(--base-5)",
    6: "var(--base-6)",
    7: "var(--base-7)",
    8: "var(--base-8)",
    9: "var(--base-9)",
    10: "var(--base-10)",
    11: "var(--base-11)",
    12: "var(--base-12)",
  },
  gray: {
    1: "var(--gray-1)",
    2: "var(--gray-2)",
    3: "var(--gray-3)",
    4: "var(--gray-4)",
    5: "var(--gray-5)",
    6: "var(--gray-6)",
    7: "var(--gray-7)",
    8: "var(--gray-8)",
    9: "var(--gray-9)",
    10: "var(--gray-10)",
    11: "var(--gray-11)",
    12: "var(--gray-12)",
    a1: "var(--gray-a1)",
    a2: "var(--gray-a2)",
    a3: "var(--gray-a3)",
    a4: "var(--gray-a4)",
    a5: "var(--gray-a5)",
    a6: "var(--gray-a6)",
    a7: "var(--gray-a7)",
    a8: "var(--gray-a8)",
    a9: "var(--gray-a9)",
    a10: "var(--gray-a10)",
    a11: "var(--gray-a11)",
    a12: "var(--gray-a12)",
  },
  status: {
    error: {
      1: "var(--status-error-1)",
      2: "var(--status-error-2)",
      3: "var(--status-error-3)",
      4: "var(--status-error-4)",
      5: "var(--status-error-5)",
      6: "var(--status-error-6)",
      7: "var(--status-error-7)",
      8: "var(--status-error-8)",
      9: "var(--status-error-9)",
      10: "var(--status-error-10)",
      11: "var(--status-error-11)",
      12: "var(--status-error-12)",
      a1: "var(--status-error-a1)",
      a2: "var(--status-error-a2)",
      a3: "var(--status-error-a3)",
      a4: "var(--status-error-a4)",
      a5: "var(--status-error-a5)",
      a6: "var(--status-error-a6)",
      a7: "var(--status-error-a7)",
      a8: "var(--status-error-a8)",
      a9: "var(--status-error-a9)",
      a10: "var(--status-error-a10)",
      a11: "var(--status-error-a11)",
      a12: "var(--status-error-a12)",
    },
    warning: {
      1: "var(--status-warning-1)",
      2: "var(--status-warning-2)",
      3: "var(--status-warning-3)",
      4: "var(--status-warning-4)",
      5: "var(--status-warning-5)",
      6: "var(--status-warning-6)",
      7: "var(--status-warning-7)",
      8: "var(--status-warning-8)",
      9: "var(--status-warning-9)",
      10: "var(--status-warning-10)",
      11: "var(--status-warning-11)",
      12: "var(--status-warning-12)",
      a1: "var(--status-warning-a1)",
      a2: "var(--status-warning-a2)",
      a3: "var(--status-warning-a3)",
      a4: "var(--status-warning-a4)",
      a5: "var(--status-warning-a5)",
      a6: "var(--status-warning-a6)",
      a7: "var(--status-warning-a7)",
      a8: "var(--status-warning-a8)",
      a9: "var(--status-warning-a9)",
      a10: "var(--status-warning-a10)",
      a11: "var(--status-warning-a11)",
      a12: "var(--status-warning-a12)",
    },
    success: {
      1: "var(--status-success-1)",
      2: "var(--status-success-2)",
      3: "var(--status-success-3)",
      4: "var(--status-success-4)",
      5: "var(--status-success-5)",
      6: "var(--status-success-6)",
      7: "var(--status-success-7)",
      8: "var(--status-success-8)",
      9: "var(--status-success-9)",
      10: "var(--status-success-10)",
      11: "var(--status-success-11)",
      12: "var(--status-success-12)",
      a1: "var(--status-success-a1)",
      a2: "var(--status-success-a2)",
      a3: "var(--status-success-a3)",
      a4: "var(--status-success-a4)",
      a5: "var(--status-success-a5)",
      a6: "var(--status-success-a6)",
      a7: "var(--status-success-a7)",
      a8: "var(--status-success-a8)",
      a9: "var(--status-success-a9)",
      a10: "var(--status-success-a10)",
      a11: "var(--status-success-a11)",
      a12: "var(--status-success-a12)",
    },
    feature: {
      1: "var(--status-feature-1)",
      2: "var(--status-feature-2)",
      3: "var(--status-feature-3)",
      4: "var(--status-feature-4)",
      5: "var(--status-feature-5)",
      6: "var(--status-feature-6)",
      7: "var(--status-feature-7)",
      8: "var(--status-feature-8)",
      9: "var(--status-feature-9)",
      10: "var(--status-feature-10)",
      11: "var(--status-feature-11)",
      12: "var(--status-feature-12)",
      a1: "var(--status-feature-a1)",
      a2: "var(--status-feature-a2)",
      a3: "var(--status-feature-a3)",
      a4: "var(--status-feature-a4)",
      a5: "var(--status-feature-a5)",
      a6: "var(--status-feature-a6)",
      a7: "var(--status-feature-a7)",
      a8: "var(--status-feature-a8)",
      a9: "var(--status-feature-a9)",
      a10: "var(--status-feature-a10)",
      a11: "var(--status-feature-a11)",
      a12: "var(--status-feature-a12)",
    },
    info: {
      1: "var(--status-info-1)",
      2: "var(--status-info-2)",
      3: "var(--status-info-3)",
      4: "var(--status-info-4)",
      5: "var(--status-info-5)",
      6: "var(--status-info-6)",
      7: "var(--status-info-7)",
      8: "var(--status-info-8)",
      9: "var(--status-info-9)",
      10: "var(--status-info-10)",
      11: "var(--status-info-11)",
      12: "var(--status-info-12)",
      a1: "var(--status-info-a1)",
      a2: "var(--status-info-a2)",
      a3: "var(--status-info-a3)",
      a4: "var(--status-info-a4)",
      a5: "var(--status-info-a5)",
      a6: "var(--status-info-a6)",
      a7: "var(--status-info-a7)",
      a8: "var(--status-info-a8)",
      a9: "var(--status-info-a9)",
      a10: "var(--status-info-a10)",
      a11: "var(--status-info-a11)",
      a12: "var(--status-info-a12)",
    },
  },
  lime: {
    1: "var(--lime-1)",
    2: "var(--lime-2)",
    3: "var(--lime-3)",
    4: "var(--lime-4)",
    5: "var(--lime-5)",
    6: "var(--lime-6)",
    7: "var(--lime-7)",
    8: "var(--lime-8)",
    9: "var(--lime-9)",
    10: "var(--lime-10)",
    11: "var(--lime-11)",
    12: "var(--lime-12)",
    a1: "var(--lime-a1)",
    a2: "var(--lime-a2)",
    a3: "var(--lime-a3)",
    a4: "var(--lime-a4)",
    a5: "var(--lime-a5)",
    a6: "var(--lime-a6)",
    a7: "var(--lime-a7)",
    a8: "var(--lime-a8)",
    a9: "var(--lime-a9)",
    a10: "var(--lime-a10)",
    a11: "var(--lime-a11)",
    a12: "var(--lime-a12)",
  },
  pink: {
    1: "var(--pink-1)",
    2: "var(--pink-2)",
    3: "var(--pink-3)",
    4: "var(--pink-4)",
    5: "var(--pink-5)",
    6: "var(--pink-6)",
    7: "var(--pink-7)",
    8: "var(--pink-8)",
    9: "var(--pink-9)",
    10: "var(--pink-10)",
    11: "var(--pink-11)",
    12: "var(--pink-12)",
    a1: "var(--pink-a1)",
    a2: "var(--pink-a2)",
    a3: "var(--pink-a3)",
    a4: "var(--pink-a4)",
    a5: "var(--pink-a5)",
    a6: "var(--pink-a6)",
    a7: "var(--pink-a7)",
    a8: "var(--pink-a8)",
    a9: "var(--pink-a9)",
    a10: "var(--pink-a10)",
    a11: "var(--pink-a11)",
    a12: "var(--pink-a12)",
  },
  plum: {
    1: "var(--plum-1)",
    2: "var(--plum-2)",
    3: "var(--plum-3)",
    4: "var(--plum-4)",
    5: "var(--plum-5)",
    6: "var(--plum-6)",
    7: "var(--plum-7)",
    8: "var(--plum-8)",
    9: "var(--plum-9)",
    10: "var(--plum-10)",
    11: "var(--plum-11)",
    12: "var(--plum-12)",
    a1: "var(--plum-a1)",
    a2: "var(--plum-a2)",
    a3: "var(--plum-a3)",
    a4: "var(--plum-a4)",
    a5: "var(--plum-a5)",
    a6: "var(--plum-a6)",
    a7: "var(--plum-a7)",
    a8: "var(--plum-a8)",
    a9: "var(--plum-a9)",
    a10: "var(--plum-a10)",
    a11: "var(--plum-a11)",
    a12: "var(--plum-a12)",
  },
  jade: {
    1: "var(--jade-1)",
    2: "var(--jade-2)",
    3: "var(--jade-3)",
    4: "var(--jade-4)",
    5: "var(--jade-5)",
    6: "var(--jade-6)",
    7: "var(--jade-7)",
    8: "var(--jade-8)",
    9: "var(--jade-9)",
    10: "var(--jade-10)",
    11: "var(--jade-11)",
    12: "var(--jade-12)",
    a1: "var(--jade-a1)",
    a2: "var(--jade-a2)",
    a3: "var(--jade-a3)",
    a4: "var(--jade-a4)",
    a5: "var(--jade-a5)",
    a6: "var(--jade-a6)",
    a7: "var(--jade-a7)",
    a8: "var(--jade-a8)",
    a9: "var(--jade-a9)",
    a10: "var(--jade-a10)",
    a11: "var(--jade-a11)",
    a12: "var(--jade-a12)",
  },
  amber: {
    1: "var(--amber-1)",
    2: "var(--amber-2)",
    3: "var(--amber-3)",
    4: "var(--amber-4)",
    5: "var(--amber-5)",
    6: "var(--amber-6)",
    7: "var(--amber-7)",
    8: "var(--amber-8)",
    9: "var(--amber-9)",
    10: "var(--amber-10)",
    11: "var(--amber-11)",
    12: "var(--amber-12)",
    a1: "var(--amber-a1)",
    a2: "var(--amber-a2)",
    a3: "var(--amber-a3)",
    a4: "var(--amber-a4)",
    a5: "var(--amber-a5)",
    a6: "var(--amber-a6)",
    a7: "var(--amber-a7)",
    a8: "var(--amber-a8)",
    a9: "var(--amber-a9)",
    a10: "var(--amber-a10)",
    a11: "var(--amber-a11)",
    a12: "var(--amber-a12)",
  },
  brown: {
    1: "var(--brown-1)",
    2: "var(--brown-2)",
    3: "var(--brown-3)",
    4: "var(--brown-4)",
    5: "var(--brown-5)",
    6: "var(--brown-6)",
    7: "var(--brown-7)",
    8: "var(--brown-8)",
    9: "var(--brown-9)",
    10: "var(--brown-10)",
    11: "var(--brown-11)",
    12: "var(--brown-12)",
    a1: "var(--brown-a1)",
    a2: "var(--brown-a2)",
    a3: "var(--brown-a3)",
    a4: "var(--brown-a4)",
    a5: "var(--brown-a5)",
    a6: "var(--brown-a6)",
    a7: "var(--brown-a7)",
    a8: "var(--brown-a8)",
    a9: "var(--brown-a9)",
    a10: "var(--brown-a10)",
    a11: "var(--brown-a11)",
    a12: "var(--brown-a12)",
  },
  indigo: {
    1: "var(--indigo-1)",
    2: "var(--indigo-2)",
    3: "var(--indigo-3)",
    4: "var(--indigo-4)",
    5: "var(--indigo-5)",
    6: "var(--indigo-6)",
    7: "var(--indigo-7)",
    8: "var(--indigo-8)",
    9: "var(--indigo-9)",
    10: "var(--indigo-10)",
    11: "var(--indigo-11)",
    12: "var(--indigo-12)",
    a1: "var(--indigo-a1)",
    a2: "var(--indigo-a2)",
    a3: "var(--indigo-a3)",
    a4: "var(--indigo-a4)",
    a5: "var(--indigo-a5)",
    a6: "var(--indigo-a6)",
    a7: "var(--indigo-a7)",
    a8: "var(--indigo-a8)",
    a9: "var(--indigo-a9)",
    a10: "var(--indigo-a10)",
    a11: "var(--indigo-a11)",
    a12: "var(--indigo-a12)",
  },
} as const;

export const FONT_TOKENS = {
  size: {
    "size-1": "var(--font-size-1)",
    "size-2": "var(--font-size-2)",
    "size-3": "var(--font-size-3)",
    "size-4": "var(--font-size-4)",
    "size-5": "var(--font-size-5)",
    "size-6": "var(--font-size-6)",
    "size-7": "var(--font-size-7)",
    "size-8": "var(--font-size-8)",
    "size-9": "var(--font-size-9)",
    "size-10": "var(--font-size-10)",
    "size-11": "var(--font-size-11)",
    "size-12": "var(--font-size-12)",
  },
  weight: {
    light: "var(--font-weight-light)",
    normal: "var(--font-weight-normal)",
    medium: "var(--font-weight-medium)",
    semibold: "var(--font-weight-semibold)",
    bold: "var(--font-weight-bold)",
  },
  height: {
    "height-1": "var(--font-height-1)",
    "height-2": "var(--font-height-2)",
    "height-3": "var(--font-height-3)",
    "height-4": "var(--font-height-4)",
    "height-5": "var(--font-height-5)",
    "height-6": "var(--font-height-6)",
    "height-7": "var(--font-height-7)",
    "height-8": "var(--font-height-8)",
    "height-9": "var(--font-height-9)",
    "height-10": "var(--font-height-10)",
    "height-11": "var(--font-height-11)",
    "height-12": "var(--font-height-12)",
  },
  spacing: {
    "spacing-1": "var(--font-spacing-1)",
    "spacing-2": "var(--font-spacing-2)",
    "spacing-3": "var(--font-spacing-3)",
    "spacing-4": "var(--font-spacing-4)",
    "spacing-5": "var(--font-spacing-5)",
    "spacing-6": "var(--font-spacing-6)",
    "spacing-7": "var(--font-spacing-7)",
    "spacing-8": "var(--font-spacing-8)",
    "spacing-9": "var(--font-spacing-9)",
    "spacing-10": "var(--font-spacing-10)",
    "spacing-11": "var(--font-spacing-11)",
    "spacing-12": "var(--font-spacing-12)",
  },
  family: {
    code: "var(--font-family-code)",
    text: "var(--font-family-text)",
    heading: "var(--font-family-heading)",
    sans: "var(--font-family-sans)",
  },
} as const;

export const RADIUS_TOKENS = {
  radius: {
    "radius-1": "var(--radius-1)",
    "radius-2": "var(--radius-2)",
    "radius-3": "var(--radius-3)",
    "radius-4": "var(--radius-4)",
    "radius-5": "var(--radius-5)",
    "radius-6": "var(--radius-6)",
    "radius-7": "var(--radius-7)",
    "radius-8": "var(--radius-8)",
    "radius-9": "var(--radius-9)",
    "radius-10": "var(--radius-10)",
    "radius-11": "var(--radius-11)",
    "radius-12": "var(--radius-12)",
    "radius-13": "var(--radius-13)",
    "radius-14": "var(--radius-14)",
    "radius-15": "var(--radius-15)",
    "radius-16": "var(--radius-16)",
    "radius-17": "var(--radius-17)",
    "radius-18": "var(--radius-18)",
    "radius-full": "var(--radius-full)",
  },
} as const;

export const SPACING_TOKENS = {
  spacing: {
    "layout-spacing-1": "var(--layout-spacing-1)",
    "layout-spacing-2": "var(--layout-spacing-2)",
    "layout-spacing-3": "var(--layout-spacing-3)",
    "layout-spacing-4": "var(--layout-spacing-4)",
    "layout-spacing-5": "var(--layout-spacing-5)",
    "layout-spacing-6": "var(--layout-spacing-6)",
    "layout-spacing-7": "var(--layout-spacing-7)",
    "layout-spacing-8": "var(--layout-spacing-8)",
    "layout-spacing-9": "var(--layout-spacing-9)",
    "layout-spacing-10": "var(--layout-spacing-10)",
    "layout-spacing-11": "var(--layout-spacing-11)",
    "layout-spacing-12": "var(--layout-spacing-12)",
    "layout-spacing-13": "var(--layout-spacing-13)",
    "layout-spacing-14": "var(--layout-spacing-14)",
    "layout-spacing-15": "var(--layout-spacing-15)",
    "layout-spacing-16": "var(--layout-spacing-16)",
    "layout-spacing-17": "var(--layout-spacing-17)",
    "layout-spacing-18": "var(--layout-spacing-18)",
    "layout-spacing-19": "var(--layout-spacing-19)",
    "layout-spacing-20": "var(--layout-spacing-20)",
    "layout-spacing-21": "var(--layout-spacing-21)",
  },
} as const;

export const SHADOW_TOKENS = {
  shadow: {
    "shadow-light-mode-3": "var(--shadow-light-mode-3)",
    "shadow-table-edit-cell": "var(--shadow-table-edit-cell)",
  },
} as const;

export const DESIGN_TOKENS = {
  colors: COLOR_TOKENS,
};
